import { gql } from "@apollo/client";

export const GET_ALL_TIPO_ARCHIVO_DOCUMENTOS = gql`
query allTipoArchivoDocumento{
  allTipoArchivoDocumento{
    idTipoArchivoDocumento
    value
  }
}
`;

export const adaptTipoArchivo = (tipo) => ({
  id: tipo?.idTipoArchivoDocumento,
  displayName: tipo?.value
});

export const adaptTipoArchivoArray = (tipos) =>
tipos?.allTipoArchivoDocumento?.map((tipo) => structuredClone(adaptTipoArchivo(tipo)));